module.exports = __webpack_public_path__ + "img/rob.005bbf8e.png";